export const SHOW_MASTER_SEQUENCE_OPTION = true

export const MASTER_ROUTE_ID = 'MASTER'

// Activity is split into two top-level tabs (per the hh-master-sequence
// prototype): one for the master sequence's version history, one for daily
// runs. The legacy `ACTIVITY` value remains because deep links and any
// persisted-tab state still reference it; ActivityView routes both new
// values + the legacy one to the same panel.
export const MASTER_ROUTE_TABS = {
  BOARD: 'Board',
  MAP: 'Map',
  MASTER_ACTIVITY: 'Master activity',
  DAILY_ACTIVITY: 'Daily activity',
  ACTIVITY: 'Activity',
  PRODUCTIVITY: 'Productivity',
}

export const LIVE_BRANCH_ID = 'Live'

export const ACTIVITY_TYPES = {
  MASTER: 'Master activity',
  DAILY: 'Daily activity',
}

export const FORM_FIELDS = {
  versionContext: crypto.randomUUID(),
  routeId: '',
  dayOfWeek: '',
  unassignedDate: null,
  assignSequence: '',
  gridCheckBoxSelection: {},
  branchId: LIVE_BRANCH_ID,
  branchName: '',
  activityType: ACTIVITY_TYPES.MASTER,
  activityDailyDate: new Date(),
}

// Three-row sub-toolbar reserved height: ~3 rows × 40 px (rows breathe better
// with ~40 px each) + ~8 px top padding + per-row 6 px gap. Restored from a
// previous over-tighten (124 px) that left the rows feeling cramped vs the
// prototype. xs keeps a taller allowance because rows wrap to stacked
// single-columns on narrow viewports.
export const HEADER_HEIGHT = {
  xs: '216px',
  md: '144px',
}

export const STATE_KEY_PREV_PATH_PARAMS = 'prevPathParams'

export const WEEKDAY_MAP = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
}
